module.exports = __webpack_public_path__ + "img/bluedrink.6a68fdbf.jpg";